import { render } from "./index.vue?vue&type=template&id=539ce7c2&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=539ce7c2&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539ce7c2"],['__file',"src/views/compress-setting/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "539ce7c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('539ce7c2', __exports__)) {
    console.log('reload')
    api.reload('539ce7c2', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=539ce7c2&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('539ce7c2', render)
  })

}


export default __exports__